import { StoreState } from '../store-interfaces';

export const chatWidgetTroubleshootingLastResultSelector = (
  state: StoreState,
) => state.chatWidgetTroubleshooting.lastResult;

export const chatWidgetTroubleshootingLastResultTimeSelector = (
  state: StoreState,
) => state.chatWidgetTroubleshooting.lastResultTime;
